class DocDocument {

    constuctor() {
        this._file = null;
    }

    _enableHandlers() {
        $("input.type-doc-input-button:last").one("change.changeDoc", this._onDocChange.bind(this));
    }

    _disableHandlers() {
        $("input.type-doc-input-button:last").off("change.changeDoc");
    }

    _onDocChange(event) {

        function _onUploadSuccess(response) {

            if (api.checkisValidResult(response)) {
                const fileUrl = response.result.url;
                documentationPublish.initialize(documentationNew.DOCUMENT, fileUrl);
            }

        }

        const $this = $(event.currentTarget);
        const that = this;
        const documentationNew = documentationScreenController.documentationNew;
        const documentationPublish = documentationScreenController.documentationPublish;

        this._file = $this[0].files[0];
        $this.prop("value", "");

        documentationPublish.drawEnterTransitionScreen();
        api.uploadDocumentPreview(this._file, _onUploadSuccess, false);

    }

    initialize() {

        const $typeDocInputButton = $("input.type-doc-input-button:last");

        this.clearData();
        this._enableHandlers();

        $typeDocInputButton.trigger("click.openFileChooser");

    }

    clearData() {
        this._file = null;
        this._disableHandlers();
    }

}
